/**
 * UTM source types for user conversion tracking
 */
export enum UtmSourceType {
  DirectTraffic = 'direct-traffic',
  DirectReferral = 'directreferral',
}

export const utmSourceType = {
  directTraffic: UtmSourceType.DirectTraffic,
  directReferral: UtmSourceType.DirectReferral,
} as const
